module.exports = __webpack_public_path__ + "static/artist-management-the-process-mobile-c47d07dd944d99060711c8fe1073ec2d.png";